export default "__VITE_ASSET__k42g_qeKBN7iMlP8_gZLtA__"